<template>
  <div class="page-content vehicle-info">
    <div class="page-form content">
      <Form
        :ref="`form-vehicle`"
        :defaultForm.sync="form"
        :fields="fields"
        :defaultText.sync="fieldTexts"
      >
        <van-field
          slot="field-custom-vin"
          v-model.trim="form.vin"
          label="车架号"
          disabled
          input-align="right"
        >
          <template #button>
            <div
              :class="['field-btn', assessIng ? 'ing' : '']"
              @click="assessFn"
            >
              {{
                successEnums.find((e) => e.value == form.assessStatusFlag)
                  ?.label
              }}
            </div>
            <!-- <span v-else class="field-btn suc">已评估</span> -->
          </template>
        </van-field>
      </Form>
    </div>

    <div class="page-btn btns">
      <van-button type="info" size="small" @click="submitFn">提交</van-button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import {
  assessVehicle,
  createVehicleInfo,
  vehicleInfo,
  orderDetailInfo,
  assessChannel
} from "@/api/apply";
import { setFormData } from "../dev_form_json";
import { getSomeEnums } from "@/api/enums";
export default {
  components: {
    Form: () => import("@/components/Form/Index")
  },
  data() {
    return {
      required: [
        {
          required: true
        }
      ],
      bizNo: "",
      evalStatus: false,
      assessSuccess: false,
      isAccident: false, // 是否事故车
      form: {},
      enums: {
        wheelEnums: [
          { text: "是", value: "Y" },
          { text: "否", value: "N" }
        ]
      },
      fieldTexts: {},
      successEnums: [
        { label: "待提交评估", value: "0" },
        { label: "取消评估", value: "1" },
        { label: "评估中", value: "2" },
        { label: "已评估", value: "3" },
        { label: "拒评", value: "4" },
        { label: "驳回", value: "5" }
      ]
    };
  },
  computed: {
    assessIng() {
      return [2, 3].includes(this.form.assessStatusFlag);
    },
    fields() {
      let arr = [
        {
          type: "text",
          label: "车牌",
          disabled: true,
          key: "carPlateNum"
        },
        {
          type: "custom",
          label: "车架号",
          key: "vin"
        },
        {
          type: "date",
          label: "购买时间",
          required: true,
          config: {
            maxDate: new Date(Date.now())
          },
          key: "purchaseDate"
        },
        {
          type: "amount",
          label: "购买金额(元)",
          decimal: 2,
          required: true,
          key: "purchaseAmount"
        },
        {
          type: "select",
          label: "车身级别",
          required: true,
          key: "carBodyClass",
          enums: this.enums?.carBodyClassEnums || []
        },
        {
          type: "number",
          label: "车辆累计过户次数",
          required: true,
          key: "transferNumber"
        },
        {
          type: "number",
          label: "近一年内过户次数",
          labelWidth: "8em",
          required: true,
          key: "yearTransferNumber"
        },
        {
          type: "select",
          label: "是否存在过户记录",
          required: true,
          labelWidth: "8em",
          key: "transferFlag",
          enums: this.enums?.wheelEnums || [],
          tips: "说明：公司户过户给法人或股东，直系过户给本人，本人户过其他城市车牌"
        },
        {
          type: "select",
          label: "征信是否体现上笔车贷",
          required: true,
          key: "previousCarLoanFlag",
          enums: this.enums?.wheelEnums || []
        },
        {
          type: "select",
          label: "是否按揭车",
          required: true,
          key: "mortgagedCarFlag",
          enums: this.enums?.wheelEnums || []
        },
        ...(this.form.mortgagedCarFlag == "Y"
          ? [
              {
                type: "select",
                label: "是否还满12期且最近6期还款正常",
                required: true,
                labelWidth: "8em",
                key: "repayNormalFlag",
                enums: this.enums?.wheelEnums || [],
                tips: "说明：未结清车贷,正常还款满12期且最后6期还款正常"
              }
            ]
          : [])
      ];
      // if (this.form.releasePledge == 0) {
      //   let otherFields = [
      //     {
      //       type: "date",
      //       label: "车辆解押日期",
      //       required: true,
      //       config: {
      //         maxDate: new Date(Date.now())
      //       },
      //       key: "releasePledgeDate"
      //     },
      //     {
      //       type: "text",
      //       label: "上笔抵押主体名称",
      //       labelWidth: "8em",
      //       required: true,
      //       key: "previousOneMortgage"
      //     }
      //   ];
      //   arr = arr.concat(otherFields);
      // }
      // if (this.form.releasePledge == 1) {
      //   let otherFields = [
      //     {
      //       type: "text",
      //       label: "上笔抵押主体名称",
      //       labelWidth: "8em",
      //       required: true,
      //       key: "previousOneMortgage"
      //     }
      //   ];
      //   arr = arr.concat(otherFields);
      // }

      return arr;
    }
  },
  mounted() {
    this.getAllEnums();
    this.init();

    // window.agilityAutoFill = this.agilityAutoFill;
  },
  methods: {
    ...mapGetters(["getUserOrderInfo"]),
    init() {
      const data = this.getUserOrderInfo();
      this.bizNo = data.bizNo || "";
      // this.getAssessChannel();
      this.getApplyInfo();
    },
    async getAssessChannel() {
      try {
        const { data } = await assessChannel(this.bizNo);
        this.evalStatus = data.evalStatus == "Y";
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async getAllEnums() {
      try {
        const [d2, d3] = await Promise.all([
          getSomeEnums("loanPurpose"),
          getSomeEnums("carBodyClassEnums")
        ]);
        this.$set(this.enums, "loanUseEnums", d2);
        this.$set(this.enums, "carBodyClassEnums", d3);
      } catch (error) {
        console.log("error :>> ", error);
        this.$errMsg(error);
      }
    },
    // 申请信息
    async getApplyInfo() {
      try {
        this.loading = true;
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const { data } = await orderDetailInfo(this.bizNo);
        const {
          carPlateNum,
          vin,
          assessStatus,
          accidentLevel,
          carValue,
          purchaseDate,
          assessStatusFlag
        } = data;
        this.$set(this.form, "carPlateNum", carPlateNum);
        this.$set(this.form, "vin", vin);
        this.$set(this.form, "purchaseDate", purchaseDate);
        this.$set(this.form, "assessStatusFlag", assessStatusFlag);
        if (accidentLevel)
          this.$set(
            this.form,
            "accidentLevel",
            [1, 2].includes(+accidentLevel) ? "是" : "否"
          );
        this.assessSuccess = assessStatus;
        if (assessStatus) {
          const v2carValue = this.$route.query.carValue;
          this.$set(this.form, "carValue", v2carValue || carValue || "");
        }

        this.getVehicleInfo();

        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      } finally {
        this.loading = false;
      }
    },
    async getVehicleInfo() {
      try {
        this.$toast.loading({
          forbidClick: true,
          duration: 0
        });
        const { data } = await vehicleInfo(this.bizNo);
        const keys = this.fields.map((e) => e.key);

        keys.map((k) => {
          if (data[k]) {
            if (k == "loanUse")
              this.$nextTick(() => {
                this.$set(this.form, k, data[k]);
              });
            else this.$set(this.form, k, data[k]);
          }
        });

        if (data.releasePledge == 0) {
          // 已解押 设置解押日期
          this.$nextTick(() => {
            this.$set(
              this.form,
              "releasePledgeDate",
              data["releasePledgeDate"]
            );
          });
        }
        this.$toast.clear();
      } catch (error) {
        this.$errMsg(error);
      }
    },
    async assessFn() {
      if (this.assessIng) {
        return;
      }
      this.$router.push("/vehicle-assess");
      // if (this.evalStatus) this.$router.push("/vehicle-assess");
      // else {
      //   try {
      //     this.assessIng = true;
      //     await assessVehicle(this.bizNo);
      //     this.getApplyInfo();
      //   } catch (error) {
      //     this.$errMsg(error);
      //   } finally {
      //     this.assessIng = false;
      //   }
      // }
    },
    async submitFn() {
      try {
        if (!this.assessSuccess) throw "请先评估后再提交";
        const infodom = this.$refs["form-vehicle"];
        await infodom.validate();
        const params = {
          bizNo: this.bizNo,
          ...this.form
        };
        this.$toast.loading({
          message: "处理中...",
          forbidClick: true,
          duration: 0
        });
        await createVehicleInfo(params);
        this.$toast.clear();
        this.$router.push("/apply-detail");
      } catch (error) {
        this.$errMsg(error);
      }
    },
    // 开发快速调试
    agilityAutoFill() {
      let isdev = process.env.NODE_ENV === "development";
      if (isdev) {
        setFormData(this, "form", "apply_form_data_car_form");
      }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "./input-style.scss";
.vehicle-info {
  .field-btn {
    &.ing {
      color: #666;
    }
    &.suc {
      color: #52c41a;
    }
  }
  .btns {
    .van-button {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
